import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Image, Button } from 'antd';
import NotFoundPageImage from '@assets/images/not-found-page-image.png';

const NotFoundPage = () => {
  const navigate = useNavigate();

  return (
    <div className="w-full flex justify-center mb-5">
      <div className="w-2/5	flex flex-col items-center">
        <Image src={NotFoundPageImage} preview={false} />
        <div className="flex">
          <Button
            size="large"
            type="primary"
            className="bg-secondary w-full"
            onClick={() => navigate('/')}
          >
            Visit your Dashboard
          </Button>
        </div>
      </div>
    </div>
  );
};

export default NotFoundPage;
